module.exports = __webpack_public_path__ + "static/Flow Data Table Product Brief-34c193e3e5bee3b435e9598edb910a5b.pdf";